import { ISegmentDefinition } from '../../types';

export const Computer: ISegmentDefinition = {
  segment: 'Computer',
  titleKey: 'Segment_Device_Type_Computer',
};

export const SmartPhone: ISegmentDefinition = {
  segment: 'SmartPhone',
  titleKey: 'Segment_Device_Type_Smartphone',
};

export const Tablet: ISegmentDefinition = {
  segment: 'Tablet',
  titleKey: 'Segment_Device_Type_Tablet',
};
